module.exports = __webpack_public_path__ + "img/crane-offline.12558f2f.png";